<template>
    <div>
        <template v-if="isAuthorized">
            <v-row no-gutters class="my-3 justify-center">
                <v-col cols="2" class="pl-2">
                    <v-btn-primary @click="addItem(accountingItems.length)" block
                        >Ajouter</v-btn-primary
                    >
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : '6'" class="pl-2">
                    <oss-filter-bar
                        v-model:type="type"
                        :showTypeTag="false"
                        v-model:text="search"
                        v-model:startDate="beginDate"
                        v-model:endDate="endDate"
                        :minDate="minDate"
                        :maxDate="maxDate"
                        :showStatusTag="false"
                        :statusIsManadatory="true"
                        :dateIsManadatory="true"
                        v-model:thirdPartyCompanyName="thirdPartyCompanyName"
                        :minPrice="minAmount"
                        @update:minPrice="
                            ($event) => {
                                documentType === 'PURCHASE_INVOICE'
                                    ? (maxAmount = -$event + '')
                                    : (minAmount = $event + '');
                            }
                        "
                        :maxPrice="maxAmount"
                        @update:maxPrice="
                            ($event) => {
                                documentType === 'PURCHASE_INVOICE'
                                    ? (minAmount = -$event + '')
                                    : (maxAmount = $event + '');
                            }
                        "
                        :types-list="
                            logTypes.map((type) => {
                                return { value: type, text: formatType(type) };
                            })
                        "
                        :status-list="
                            allDocumentStatus.map((type) => {
                                return { value: type, text: formatStatus(type) };
                            })
                        "
                        :companyId="selectedCompany.id"
                    />
                    <!-- :limitMinPrice="documentType === 'PURCHASE_INVOICE' ? -maxDocumentAmount : minDocumentAmount"
                    :limitMaxPrice="documentType === 'PURCHASE_INVOICE' ? -minDocumentAmount : maxDocumentAmount"
                    :tags="documentTags" @tags="setDocumentTags"
                    :status="documentStatus" @status="documentStatus = $event"
                    -->
                </v-col>
                <v-col cols="2" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        :model-value="'Debit : ' + newCommonFormatCurrency(totalDebit, undefined)"
                        density="compact"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="2" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        :model-value="'Crédit : ' + newCommonFormatCurrency(totalCredit, undefined)"
                        density="compact"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="showQuickAccounting" class="px-2 justify-center">
                <v-col cols="12">
                    <table class="oss-dense-table" width="100%">
                        <thead>
                            <tr>
                                <th class="text-center" width="10%" />
                                <th class="text-center" width="10%">Journal</th>
                                <th class="text-center" width="10%">Date</th>
                                <th class="text-acenter" width="10%">N&#xb0; de pièce</th>
                                <th class="text-center" width="12%">Compte</th>
                                <th class="text-center" width="12%">Libellé</th>
                                <th class="text-center" width="12%">Débit</th>
                                <th class="text-center" width="12%">Crédit</th>
                                <th class="text-center" width="12%" />
                            </tr>
                        </thead>
                    </table>
                </v-col>
                <v-col cols="12">
                    <template v-for="(item, index) in accountingItems">
                        <AccountingItemEdition2
                            v-if="!accountingItems[index].isRemoved"
                            :key="index"
                            :companyId="selectedCompany.id"
                            @item-is-valid="
                                (autocompletion, log, date) =>
                                    makeItemValid(index, autocompletion, log, date)
                            "
                            @item-is-not-valid="makeItemInvalid(index)"
                            @add-item="addItem(index + 1)"
                            @remove-item="removeItem(index)"
                            :editionIndex="index"
                            :defaultAutoCompletion="accountingItems[index].autocompletion"
                            :defaultLog="accountingItems[index].log"
                            :defaultDate="accountingItems[index].date"
                        />
                    </template>
                </v-col>
                <v-col cols="auto">
                    <v-btn-primary @click="validateItems" block :disabled="disableValidButton"
                        >Valider</v-btn-primary
                    >
                </v-col>
            </v-row>
            <v-data-table-server
                :headers="headers"
                :items="accountingLines"
                :page="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.descending"
                :items-per-page="pagination.rowsPerPage"
                :items-length="pagination.totalItems"
                :items-per-page-options="[5, 10, 25]"
                :loading="loading"
                hide-default-footer
                calculate-widths
                fixed-header
                height="80vh"
                class="table"
                :style="{
                    minWidth: '1150px',
                    marginTop: showQuickAccounting && '30px',
                }"
                v-if="documentType !== 'MAIL'"
                density="compact"
            >
                <template #headers="{ headers, columns }">
                    <tr>
                        <th :colspan="1" style="width: 64px">
                            <div class="text-center">
                                <v-checkbox-btn
                                    color="primary"
                                    hide-details="auto"
                                    :indeterminate="
                                        selectedALIds.length !== 0 &&
                                        selectedALIds.length < accountingLines.length
                                    "
                                    :model-value="
                                        accountingLines.length &&
                                        selectedALIds.length === accountingLines.length
                                    "
                                    @click="
                                        selectedALIds.length < accountingLines.length
                                            ? (selectedALIds = [
                                                  ...accountingLines.map((x) => x.id),
                                              ])
                                            : (selectedALIds = [])
                                    "
                                >
                                </v-checkbox-btn>
                            </div>
                        </th>
                        <th v-if="toRefresh" :colspan="1">
                            <v-icon @click="refreshAccountingLines" size="small"
                                >$fa-redo-alt</v-icon
                            >
                        </th>
                        <th :colspan="columns.length" style="padding-left: 0">
                            <v-row no-gutters>
                                <!-- <v-col cols="4" class="d-flex align-center">
                                    <v-btn
                                        @click="dialogChangeThirdPartyCompanyDocument = true"
                                        rounded
                                        color="ternary"
                                        :disabled="!onlyPurchasesSelected"
                                            size="small"
                                        elevation="0"
                                        class="mr-3"
                                        v-if="isAccountingUser"
                                    >
                                        Fournisseur
                                    </v-btn>
                                    <v-btn
                                        @click="dialogChangeThirdPartyCompanyDocument = true"
                                        rounded
                                        color="ternary"
                                        :disabled="!onlySalesSelected"
                                            size="small"
                                        elevation="0"
                                        class="mr-3"
                                        v-if="isAccountingUser"
                                    >
                                        Client
                                    </v-btn>
                                    <multiple-free-tagging
                                        :company="selectedCompany"
                                        :company-tags="allCompanyTags"
                                        :selected-documents="selectedDocuments"
                                        @selected-tags="onMultiTagguingApplied"
                                    ></multiple-free-tagging>
                                    <v-menu offset-y v-if="isAccountingUser">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            >
                                                <v-icon>$dots_vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                :disabled="disabledDownload"
                                                @click="selectedALIds.length === 1 ? dialogChooseDownload = true: downloadFile(true)"
                                            >
                                                <v-list-item-title>Télécharger</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-icon  size="small">$oss-download</v-icon>
                                                </template>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item
                                                :disabled="disabledDelete"
                                                @click="dialogDeleteSelectedDocument = true"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-icon  size="small">$delete</v-icon>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col> -->
                                <v-spacer />
                                <v-col class="d-flex justify-end align-center pb-1">
                                    <v-select
                                        v-model="sortBy"
                                        :items="sortByList"
                                        style="font-size: 0.75rem; width: min-content"
                                        hide-details
                                        item-value="key"
                                        item-title="text"
                                        width="30px"
                                        prefix="Trier par"
                                        return-object
                                        density="compact"
                                    />
                                    <v-select
                                        v-model="pagination.rowsPerPage"
                                        :items="[5, 10, 25]"
                                        hide-details
                                        outlined
                                        style="font-size: 0.75rem; width: min-content"
                                        width="30px"
                                        prefix="Lignes par page"
                                        density="compact"
                                    />
                                    <span style="white-space: nowrap">
                                        {{ (pagination.page - 1) * pagination.rowsPerPage + 1 }}
                                        -
                                        {{
                                            (pagination.page - 1) * pagination.rowsPerPage +
                                            pagination.rowsPerPage
                                        }}
                                        de {{ pagination.totalItems }}
                                    </span>
                                    <v-btn-icon
                                        icon="$keyboard_arrow_left"
                                        @click="pagination.page--"
                                        :disabled="pagination.page === 1"
                                        size="small"
                                    />
                                    <v-btn-icon
                                        icon="$keyboard_arrow_right"
                                        @click="pagination.page++"
                                        :disabled="nextPageDisabled"
                                        size="small"
                                    />
                                </v-col>
                            </v-row>
                        </th>
                    </tr>
                </template>

                <template v-slot:no-data>Aucune écriture trouvée</template>
                <template v-slot:item="props">
                    <tr
                        style="cursor: pointer"
                        data-cy="accountingLines"
                        @click="props.item.openDocument()"
                    >
                        <td class="text-center">
                            <v-checkbox
                                @click.stop="addSelectedItem(props.item.id)"
                                class="pa-0 ma-0"
                                hide-details
                                :ripple="false"
                                :model-value="isSelected(props.item.id)"
                            >
                            </v-checkbox>
                        </td>
                        <td class="pl-2 pr-2 text-center" v-if="documentType === 'ALL'">
                            <b>{{ props.item.objectType }}</b>
                        </td>
                        <td class="px-0 text-center">{{ formatDate(props.item.date) }}</td>
                        <td class="pl-2 pr-2 text-left">
                            <strong>{{ props.item.accountableAccountNameTitle }}</strong>
                            {{ props.item.accountableAccountDescTitle }}
                        </td>
                        <td>
                            <v-chip
                                label
                                color="tagFree"
                                class="text mr-1"
                                v-if="props.item.tag"
                                size="x-small"
                                >{{ props.item.tag.name }}</v-chip
                            >
                            <template v-if="props.item.tags">
                                <v-chip
                                    label
                                    class="text mr-1"
                                    v-for="(tag, tagIndex) in props.item.tags"
                                    :key="tagIndex"
                                    size="x-small"
                                    ><span :style="'color:' + labelTextColor + ';'">{{
                                        tag.name
                                    }}</span></v-chip
                                >
                            </template>
                            {{ props.item.wording }}
                        </td>
                        <td>
                            {{ props.item.invoiceNumber || "" }}
                        </td>
                        <td class="text-left">{{ props.item.thirdPartyTitle }}</td>
                        <td class="px-0 text-right">
                            <span v-if="props.item.amountSigned > 0">{{
                                newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )
                            }}</span>
                        </td>
                        <td class="pl-0 pr-2 text-right">
                            <span v-if="props.item.amountSigned < 0">{{
                                newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )
                            }}</span>
                        </td>
                    </tr>
                </template>
            </v-data-table-server>
        </template>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { State2Way } from "@/decorators";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import OssFilterBar from "../ossComponents/ossFilterBar.vue";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";

import { getUserDisplayName } from "../../services/userServices";

import ACCOUNTING_LINES from "../../graphql/document/FilterAccountingLines.gql";
import { getAccountingLineQuery } from "../../services/graphqlServices";
import { openBankTransaction } from "../../services/bankTransactionServices";
import colors from "vuetify/util/colors";
import { checkAccessRights } from "../../services/accessRightServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import emitter from "./accountingLines.emits";

class AccountingLine {
    amountSigned: number;
    wording: number;
    document: any;
    bankTransaction: any;
    accountableAccount: any;
    thirdPartyCompany: any;
    user: any;
    bankAccount: any;
    component: AccountingLines;

    constructor(component) {
        this.component = component;
    }

    get invoiceNumber() {
        if (this.document?.invoiceNumber) {
            return this.document?.invoiceNumber;
        }
        return "";
    }

    get objectType() {
        if (this.document) {
            return this.component.$t("document.shortType." + this.document.type || "UNKNOWN");
        } else if (this.bankTransaction) {
            if (this.bankTransaction.account) {
                return this.bankTransaction.account.name;
            }
            return this.component.$t("document.shortType.BankTransaction");
        }
        return this.component.$t("document.shortType.UNKNOWN");
        // return "toto"
    }

    get accountableAccountNameTitle() {
        let title = "";
        if (this.accountableAccount) {
            title = this.accountableAccount.displayName || this.accountableAccount.name;
            if (title === "INTERNAL_LINK") {
                return "Lien interne";
            } else if (title) {
                return title.split("_")[0];
            }
        }
        return title;
    }

    get accountableAccountDescTitle() {
        let title = "";
        if (this.accountableAccount) {
            title += " - ";
            title += this.accountableAccount.description;
        }
        return title;
    }

    get thirdPartyTitle() {
        let title = "";
        if (this.thirdPartyCompany) {
            title = this.thirdPartyCompany.name;
        }
        if (this.user) {
            if (title) title += " - ";
            title += getUserDisplayName(this.user);
        }
        if (this.bankAccount) {
            if (title) title += " - ";
            title += this.bankAccount.name;
        }
        return title;
    }

    openDocument() {
        if (this.document) {
            // if (reconciliationIfPossible) {
            //     if (this.reconciliationIcon(document)) {
            //         this.$router.push({
            //             name: "reconciliation/document",
            //             params: {
            //                 companyId: this.selectedCompany.id,
            //                 documentId: document.id
            //             }
            //         });
            //         return
            //     }
            // }
            this.component.$router.push({
                name: "document",
                params: {
                    companyId: this.component.selectedCompany.id,
                    id: this.document.id,
                },
            });
        } else if (this.bankTransaction) {
            openBankTransaction(
                this.component.$router,
                this.component.currentUser,
                this.component.selectedCompany.id,
                this.bankTransaction,
            );
        }
    }
}

@Component({
    components: {
        AccountingItemEdition2,
        OssFilterBar,
    },
})
export class AccountingLines extends Vue {
    accountingItems: {
        companyId: string;
        isValid: boolean;
        isRemoved: boolean;
        autocompletion: boolean;
        log: string;
        date: string;
    }[] = [];
    toRefresh: boolean = false;

    @State2Way("updateAccountingLinePagination", "accountingLineFilter.pagination")
    pagination!: any;

    @State2Way("updateAccountingLineSearch", "accountingLineFilter.search")
    search!: string;

    @State2Way("updateAccountingLineBeginDate", "accountingLineFilter.date.begin")
    beginDate!: string;

    @State2Way("updateAccountingLineEndDate", "accountingLineFilter.date.end")
    endDate!: string;

    @State2Way("updateAccountingLineMaxAmount", "accountingLineFilter.amount.maximum")
    maxAmount!: string;

    @State2Way("updateAccountingLineMinAmount", "accountingLineFilter.amount.minimum")
    minAmount!: string;

    @State2Way("updateAccountingLineFilterByPrice", "accountingLineFilter.filterByPrice")
    filterByPrice!: boolean;

    @State2Way(
        "updateAccountingLineThirdPartyCompanyName",
        "accountingLineFilter.thirdPartyCompanyName",
    )
    thirdPartyCompanyName!: string;

    @State2Way("updateAccountingLineType", "accountingLineFilter.type")
    documentType!: string;

    @State2Way("updateAccountingLineAllTypes", "accountingLineFilter.allTypes")
    allDocumentTypes!: string[];

    // @State2Way("updateAccountingLineStatus", "accountingLineFilter.status")
    // documentStatus!: string;

    // @State2Way("updateAccountingLineTags", "accountingLineFilter.tags")
    // documentTags!:any[];

    // @State2Way("updateAccountingLineAuditCheck", "accountingLineFilter.auditCheck")
    // auditCheck!: string;

    // @State2Way("updateAccountingLinePartitionTagId", "accountingLineFilter.partitionTagId")
    // partitionTagId!: string;

    @State2Way("updateAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    @State2Way("updateAccountableAccountTable", "accountableAccountTable")
    accountableAccountTable;

    @Watch("selectedAccountingPeriod")
    onAccountingPeriodChanged(value, prevValue) {
        if (value) {
            if (!this.beginDate) {
                this.beginDate = moment(value.start).format("YYYY-MM-DD");
            } else {
                const mBegin = moment(this.beginDate);
                if (mBegin.isBefore(moment(value.start)) || mBegin.isAfter(moment(value.end))) {
                    this.beginDate = moment(value.start).format("YYYY-MM-DD");
                }
            }
            if (!this.endDate) {
                this.endDate = moment(value.end).format("YYYY-MM-DD");
            } else {
                const end = moment(this.endDate);
                if (end.isAfter(moment(value.end)) || end.isBefore(moment(value.start))) {
                    this.endDate = moment(value.end).format("YYYY-MM-DD");
                }
            }
        }
    }

    @Watch("search")
    @Watch("payBy")
    @Watch("reconciliationStatus")
    @Watch("amountType")
    @Watch("minAmount")
    @Watch("maxAmount")
    @Watch("beginDate")
    @Watch("endDate")
    @Watch("selectedAccount")
    @Watch("account")
    @Watch("auditCheck")
    onFilterChanged() {
        this.pagination.page = 1;
    }

    makeItemValid(index: number, autocompletion: boolean, log: string, date: string) {
        this.accountingItems[index].autocompletion = autocompletion;
        this.accountingItems[index].log = log;
        this.accountingItems[index].date = date;
        this.accountingItems[index].isValid = true;
    }

    makeItemInvalid(index: number) {
        this.accountingItems[index].isValid = false;
    }

    addItem(index: number) {
        const autocompletion = index === 0 ? false : this.accountingItems[index - 1].autocompletion;
        const log = index === 0 ? "MISCELLANEOUS_OPERATION" : this.accountingItems[index - 1].log;
        const date = index === 0 ? "" : this.accountingItems[index - 1].date;
        this.accountingItems.push({
            companyId: this.selectedCompany.id,
            isValid: false,
            isRemoved: false,
            autocompletion: autocompletion,
            log: log,
            date: date,
        });
    }

    removeItem(index: number) {
        this.accountingItems[index].isRemoved = true;
        if (!this.accountingItems.some((item) => !item.isRemoved)) {
            this.accountingItems = [];
        }
    }

    validateItems() {
        emitter.$emit("validate-item"); // event emitted for each child
        for (let i = 0; i < this.accountingItems.length; i++) {
            this.removeItem(i);
        }
        this.toRefresh = true;
    }

    refreshAccountingLines() {
        this.$apollo.queries.accountingLines.refetch();
        this.toRefresh = false;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get showQuickAccounting(): boolean {
        if (this.accountingItems.some((item) => !item.isRemoved)) {
            return true;
        }
        return false;
    }

    get disableValidButton(): boolean {
        if (this.accountingItems.some((item) => !item.isRemoved && !item.isValid)) {
            return true;
        }
        return false;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "accountingLine");
        return authorized;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get documentTypes() {
        return [
            "SALES_INVOICE",
            "SALES_INVOICE_AUTO",
            "ZTILL_RECEIPT",
            "PURCHASE_INVOICE",
            "CURRENT_ACCOUNT",
            "OPERATOR_ACCOUNT",
            "PAY_SLIP",
            "MISCELLANEOUS_OPERATION",
            "CARRY_FORWARD",
            "WITH_DELTA",
            "EXPENSE_REPORT",
            "WITHOUT_INVOICE",
            "VAT",
            "BANK_CHARGE",
            "WAITING_CASHING",
        ];
    }

    type_ = "ALL";

    get type() {
        return this.type_;
    }

    set type(value) {
        this.type_ = value;
        this.documentType = value;
    }

    get logTypes() {
        const types = ["ALL"];
        types.push(...this.documentTypes);
        types.push("BANK_TRANSACTION");
        return types;
    }

    get headers() {
        const headers = [];
        headers.push({
            title: "",
            value: "",
            sortable: false,
            align: "center",
            // width: undefined,
        });
        if (this.type === "ALL") {
            headers.push({
                title: "Type",
                value: "",
                sortable: false,
                align: "left",
                // width: undefined,
            });
        }
        headers.push({
            title: "Date",
            value: "date",
            sortable: true,
            align: "left",
            // width: undefined,
        });
        headers.push({
            title: "Compte comptable",
            value: "accountableAccount",
            sortable: false,
            align: "left",
            // width: undefined,
        });
        headers.push({
            title: "Libellé",
            value: "wording",
            sortable: false,
            align: "center",
            // width: undefined,
        });
        headers.push({
            title: "N° Facture",
            value: "invoiceNumber",
            sortable: true,
            align: "center",
            // width: undefined,
        });
        headers.push({
            title: "Fournisseur/Client/Utilisateur",
            value: "thirdPartyCompany.name",
            sortable: false,
            align: "center",
            // width: undefined,
        });
        headers.push({
            // title: "Débit",
            value: "debit",
            sortable: true,
            align: "right",
            // width: undefined,
        });
        headers.push({
            // title: "Crédit",
            value: "credit",
            sortable: true,
            align: "right",
            // width: undefined,
        });

        return headers;
    }

    set sortBy(data) {
        this.pagination.sortBy = [data.value];
        this.pagination.descending = [data.descending];
    }

    get sortBy() {
        if (this.pagination && this.pagination.sortBy && this.pagination.sortBy.length) {
            let key = this.pagination.descending[0]
                ? this.pagination.sortBy[0] + "_desc"
                : this.pagination.sortBy[0] + "_asc";
            const head = this.sortByList.find((x) => x.key === key);
            if (head) {
                return {
                    key: key,
                    value: this.pagination.sortBy[0],
                    descending: this.pagination.descending[0],
                    text: head.text,
                };
            }
        }
        return null;
    }

    get sortByList() {
        const result = this.headers
            .filter((x) => x.sortable && x.title)
            .flatMap((x) => {
                const list: any = [];
                if (x.onlyDesc) {
                    list.push({
                        text: x.title,
                        value: x.value,
                        descending: false,
                        key: x.value + "_asc",
                    });
                } else {
                    list.push({
                        text: x.title + " croissant",
                        value: x.value,
                        descending: false,
                        key: x.value + "_asc",
                    });
                    list.push({
                        text: x.title + " décroissant",
                        value: x.value,
                        descending: true,
                        key: x.value + "_desc",
                    });
                }
                return list;
            });
        return result;
    }

    get filter() {
        return this.$store.state.accountingLineFilter;
    }

    selectedALIds = [];

    isSelected(id) {
        return this.selectedALIds.findIndex((x) => x === id) !== -1;
    }

    addSelectedItem(id) {
        if (this.isSelected(id)) {
            this.selectedALIds = this.selectedALIds.filter((x) => x !== id);
        } else {
            this.selectedALIds.push(id);
        }
    }

    formatDate(date) {
        if (!date) return null;
        return moment(date).format("DD MMM YYYY");
    }

    get nextPageDisabled() {
        return (
            Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) <=
            this.pagination.page
        );
    }

    @Apollo({
        query: ACCOUNTING_LINES,
        variables() {
            return getAccountingLineQuery(
                this.selectedCompany.id,
                this.selectedAccountingClosing,
                this.filter,
                this.accountableAccountTable,
            );
        },
        skip() {
            // return this.auditCheck || this.partitionTag || this.filter.type === "MAIL" || (this.filter.status !== "RECONCILIATION_MISSING" && this.filter.status !== "RECONCILIATION_DONE")
            return !this.isAuthorized || !this.selectedCompany?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.accountingLines) {
                    const accountingLines = [];
                    for (const al of data.accountingLines) {
                        accountingLines.push(Object.assign(new AccountingLine(this), al, {}));
                    }
                    this.accountingLines = accountingLines;
                    this.pagination.totalItems = data.accountingLinesConnection.aggregate.count;
                } else {
                    this.accountingLines = [];
                    // this.accountingLines2 = []
                    this.pagination.totalItems = 0;
                }
            }
        },
    })
    accountingLines: AccountingLine[] = [];

    get loading() {
        if (this.$apollo.queries.accountingLines) {
            return this.$apollo.queries.accountingLines.loading;
        }
        return false;
    }

    get minDate() {
        if (this.selectedAccountingPeriod) {
            return this.selectedAccountingPeriod.start;
        }
        return null;
    }

    get maxDate() {
        if (this.selectedAccountingPeriod) {
            return this.selectedAccountingPeriod.end;
        }
        return null;
    }

    allDocumentStatus = ["VALIDATED"];

    formatType(type) {
        return this.$t("document.type." + type);
    }

    formatStatus(status) {
        return this.$t("document.status." + status);
    }

    get totalDebit() {
        let total = 0;
        for (const al of this.accountingLines) {
            if (al.amountSigned > 0) total += al.amountSigned;
        }
        return total;
    }

    get totalCredit() {
        let total = 0;
        for (const al of this.accountingLines) {
            if (al.amountSigned < 0) total -= al.amountSigned;
        }

        return total;
    }

    get labelTextColor() {
        return colors.grey.darken2;
    }
}

export default toNative(AccountingLines);
</script>
